import { SET_LOCATION_UNITS } from './types'
import { SearchResult } from './models'

export type LocationUnitState = {
  data: SearchResult
}

const initialState: LocationUnitState = {
  data: {
    locationUnits: [],
    total: 0,
  },
}

export const locationUnitReducer = (
  state = initialState,
  action: { type: string; payload: { units: SearchResult } }
): LocationUnitState => {
  switch (action.type) {
    case SET_LOCATION_UNITS:
      return { ...state, data: action.payload.units }
    default:
      return state
  }
}
